import { userConstants } from "../../constant";

const initialState = {
  ip: "",
  countryName: "",
  countryCode: "",
  city: "",
  timezone: "",
  detected: false,
};

export function geoLocation(state = initialState, action) {
  switch (action.type) {
    case userConstants.SET_DETECTED_COUNTRY:
      return {
        ...state,
        ...action.payload,
        detected: true,
      };
    default:
      return state;
  }
}
